import React from 'react'
import { VulnerabilityPolicy } from '..'
import { css } from '@emotion/css'
import { ellipsis } from 'polished'
import { Link } from '@contrast-security-inc/design-system-typography'

export function PolicyCell({
  organizationID,
  rowData: { id: policyID, name },
  routeToEditPolicy
}: {
  readonly organizationID: string
  readonly rowData: VulnerabilityPolicy
  readonly routeToEditPolicy: (organizationID: string, policyId: string) => void
}) {
  return (
    <div
      className={css`
        display: flex;
        flex: 1;
        flex-direction: column;
      `}
    >
      <div
        className={css`
          ${ellipsis()}
        `}
      >
        <Link
          className={css`
            color: black;
            &:hover {
              text-decoration: underline;
              color: black;
            }
            &:link,
            &:visited,
            &:hover,
            &:focus {
              color: black;
            }
          `}
          onClick={() => routeToEditPolicy(organizationID, policyID)}
        >
          {name}
        </Link>
      </div>
    </div>
  )
}
